import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconNo = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={2.5} />
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M18 6 6 18"
    />
  </NcIcon>
);
export { NcIconNo };
